import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {ExcFileItem} from 'exc-upload-v2';

@Directive({
  selector: '[appExgDirectUploadV2]'
})
export class AppExgDirectUploadV2Directive {


  @Input() multiple = false;
  @Input() dnd = false;
  @Input() chunkLimitMB = 50;
  @Input() accept: string | undefined = undefined;
  @Output() filesSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() filesSelectChunked: EventEmitter<any[]> = new EventEmitter<any[]>();

  fileOver = true;
  fileInput?: HTMLInputElement;

  @HostListener('click', ['$event'])
  showFilePicker(evt: Event): void {
    evt.preventDefault();
    evt.stopPropagation();

    if (!this.fileInput) {
      const input = document.createElement('input');
      input.type = 'file';

      input.addEventListener('change', () => {
        this.processFileList(input.files);
        // optional: reset, damit gleiche Datei erneut gewählt werden kann
        input.value = '';
      });

      document.body.appendChild(input);
      this.fileInput = input;
    }

    this.fileInput.multiple = this.multiple;
    if (this.accept !== undefined) {
      this.fileInput.accept = this.accept;
    }
    this.fileInput.click();
  }

  @HostListener('dragover', ['$event'])
  onDragOver(evt: any): void {
    if (!this.dnd) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    console.log('Drag Over');
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(evt: any): void {
    if (!this.dnd) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    console.log('Drag Leave');
  }

  @HostListener('drop', ['$event'])
  onDrop(evt: any): void {
    if (!this.dnd) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    console.log('Drag Leave');
    this.fileOver = false;
    if (evt.dataTransfer.files.length > 0) {
      this.processFileList(evt.dataTransfer.files);
    }
  }

  private async processFileList(fileList: FileList | null): Promise<any> {
    const files = [];
    const promises = [];
    if (fileList != null) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < fileList.length; i++) {
        const excFile = ExcFileItem.fromFile(fileList[i]);
        files.push(excFile);
        promises.push(excFile.afterLoading.toPromise());
      }
      await Promise.all(promises);
      const fileChunks: any[] = [];
      let fileChunk: any[] = [];
      let usedSize = 0;
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < files.length; i++) {
        if (usedSize + files[i].size > this.chunkLimitMB * 1000000) {
          fileChunks.push(fileChunk);
          fileChunk = [];
          usedSize = 0;
        }
        fileChunk.push(files[i]);
        usedSize = usedSize + files[i].size;
        if (i === (files.length - 1) && fileChunk.length > 0) {
          fileChunks.push(fileChunk);
          fileChunk = [];
          usedSize = 0;
        }
      }
      this.filesSelectChunked.emit(fileChunks);
      this.filesSelect.emit(files);
    }
  }

  constructor() {
  }


}
